export function calculateIsIfchorBroker(email) {
    return /@(ifchor\.(ch|com))/i.test(email);
}



// WEBPACK FOOTER //
// ./app/helpers/realCompanies.js